import React from 'react';
import { NavLink } from 'react-router-dom';
import { HiHome, HiCurrencyDollar, HiDocumentText, HiChartBar, HiUser } from 'react-icons/hi';

const tabs = [
    { to: '/owner/dashboard', label: 'Home', Icon: HiHome },
    { to: '/owner/transactions', label: 'Transactions', Icon: HiCurrencyDollar },
    { to: '/owner/invoices', label: 'Invoices', Icon: HiDocumentText },
    { to: '/owner/statement', label: 'Statement', Icon: HiChartBar },
    { to: '/owner/profile', label: 'Profile', Icon: HiUser },
];

const OwnerNav = () => (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 shadow-lg">
        <div className="flex">
            {tabs.map(({ to, label, Icon }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) =>
                        `flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-xs font-medium transition-colors ${
                            isActive ? 'text-orange-500' : 'text-gray-400 hover:text-gray-600'
                        }`
                    }
                >
                    {({ isActive }) => (
                        <>
                            <Icon className={`w-5 h-5 ${isActive ? 'text-orange-500' : ''}`} />
                            <span>{label}</span>
                            {isActive && <span className="w-1 h-1 rounded-full bg-orange-500 mt-0.5" />}
                        </>
                    )}
                </NavLink>
            ))}
        </div>
    </nav>
);

export default OwnerNav;
